

























import '@/assets/css/components/checkbox.css';

import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { CheckboxItem } from '@/lib/formFactory/checkbox.interface';

@Component({
    name: 'CheckboxBase',
})
export default class CheckboxBlock extends Vue {
    @Model('change', { type: Boolean, default: true }) value!: boolean;
    @Prop({ default: true }) readonly modelItem!: CheckboxItem;
    @Prop({ default: '' }) readonly name!: string;
    @Prop({ default: false }) readonly disabled?: boolean;
    @Prop({ default: false }) readonly disabledAlways?: boolean;
    @Prop({ default: false }) readonly reverse!: boolean;

    updateValue(data: CheckboxItem, $event: any) {
        const value = {
            name: this.name,
            id: data.id,
            bool: $event.target.checked,
        };
        this.$emit('click', value);
        this.$emit('change', value.bool);
    }
}
